import { Injectable } from "@angular/core"
import { ApiService } from "@shared/services/api.service"
import { Observable } from "rxjs"
import { AlarmSummary } from "./models/alarm-summary"

const API = "alarm/"

@Injectable({
  providedIn: "root",
})
export class AlarmApiService {
  constructor(private apiService: ApiService) {}

  public Site = {
    /** Get PMS and key alarm settings and current status for a site */
    getAlarmSummary: (hotelId: string): Observable<AlarmSummary> => this.apiService.get<AlarmSummary>(`${API}Site/AlarmSummary?hotelId=${hotelId}`),
  }
}
